import defaultLogo from "../images/Header-Logo.svg";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { resolveLogoUrl } from "../Hooks/useTenantTheme";
import { HiMenu } from "react-icons/hi";
import { AiOutlineHome } from "react-icons/ai";
import { MdOutlineImportExport } from "react-icons/md";
import { BsDatabase } from "react-icons/bs";
import { HiUsers } from "react-icons/hi";
import { MdGpsFixed } from "react-icons/md";
import { IoNewspaperOutline } from "react-icons/io5";
import { SiGooglemeet } from "react-icons/si";
import { FaHouseUser } from "react-icons/fa";
import { ROLES } from "../constants/roles";
import { MdSystemUpdateAlt } from "react-icons/md";
import useAppUpdate from "../Hooks/useAppUpdate";
import UpdateConfirmModal from "./UpdateConfirmModal";
import VersionLabel from "./VersionLabel";

const Sidebar = ({ open, setOpen, isMapPage }) => {
  const location = useLocation();
  const handleToggle = () => setOpen(!open);
  const { updateAvailable, isConfirmOpen, isUpdating, openConfirm, closeConfirm, confirmAndReload, currentVersion } = useAppUpdate();
  const userRole = localStorage.getItem("userRole");
  const isSuperAdmin = localStorage.getItem("isSuperAdmin") === "true";
  const themeContext = useTheme();
  const logo = resolveLogoUrl(themeContext?.theme?.logoUrl) || defaultLogo;

  const SidebarData = [
    {
      title: "",
      data: [
        {
          text: "Dashboard",
          path: "/dashboard",
          icon: <AiOutlineHome />,
        },
      ],
    },
    {
      title: "Data",
      data: [
        ...(userRole === ROLES.REGIONAL_MANAGER ? [] : [
          {
            text: "  Import Data",
            path: "/import-data",
            icon: <MdOutlineImportExport />,
          },
        ]),
        {
          text: " Walking list",
          path: "/walking-list",
          icon: <BsDatabase />,
        },

        ...(userRole === ROLES.CANVASSER ? [] : [
          {
            text: "Database",
            path: "/database",
            icon: <BsDatabase />,
          },
          {
            text: "Households",
            path: "/households",
            icon: <FaHouseUser />,
          },
        ]),
        {
          text: " Canvass Map",
          path: "/canvass-map",
          icon: <MdGpsFixed />,
        },
      ].filter(Boolean),
    },
    {
      title: "Settings",
      data: [
        ...(userRole === ROLES.REGIONAL_MANAGER || userRole === ROLES.CANVASSER ? [] : [
          {
            text: " Directory",
            path: "/directory",
            icon: <HiUsers />,
          },
        ]),
        {
          text: "Surveys",
          path: "/surveyentries",
          icon: <IoNewspaperOutline />,
        },
        {
          text: "Meet Us",
          path: "/schedule-meeting",
          icon: <SiGooglemeet />,
        },
      ],
    },
    ...(isSuperAdmin || userRole === ROLES.ACCOUNT_MANAGER || userRole === ROLES.REGIONAL_MANAGER ? [
      {
        title: "Administration",
        data: [
          {
            text: "Tenant",
            path: "/tenant-management",
            icon: <HiUsers />,
          },
        ],
      },
    ] : []),
  ];

  return (
    <div className="hidden md:block ">
      <div className="absolute top-0 left-[-170px] w-[170px] h-full bg-canvas-primary">
        <div
          className=" absolute left-[180px] top-3 cursor-pointer"
          onClick={handleToggle}
        >
          <HiMenu
            className={`w-8 h-8 ${isMapPage && "bg-canvas-white rounded-full  p-1"
              }`}
          />
        </div>
        <div className="h-screen">
          <div className="bg-canvas-primary max-w-[170px] w-full h-full py-5 pr-3 flex flex-col">
            <div className="px-3">
              <Link to="/">
                <img src={logo} alt="logo" />
              </Link>
            </div>
            <UpdateConfirmModal open={isConfirmOpen} onClose={closeConfirm} onConfirm={confirmAndReload} isUpdating={isUpdating} />
            <div className="pt-5 flex-1 overflow-y-auto hide-scrollbar">
              <div>
                {SidebarData.map((ele, i) => (
                  <div key={i} className="">
                    <div className="pl-3 pt-5 text-canvas-white font-outfit font-extrabold">
                      {ele.title}
                    </div>
                    <div className="">
                      {ele.data.map((e, i) => (
                        <Link
                          className={`text-canvas-sidebar text-[15px] font-outfit font-medium py-[10px] pl-3 flex items-center gap-3 pr-3 border-b-2 border-canvas-primary hover:rounded-e-2xl hover:border-b-2 hover:border-canvas-white hover:bg-canvas-white hover:bg-opacity-10 hover:mr-3 transition-all duration-500 ease-in-out ${location.pathname === e.path &&
                            "rounded-e-2xl border-b-2 border-canvas-white bg-canvas-white bg-opacity-10 text-canvas-white hover:mr-3"
                            }`}
                          to={e.path}
                          key={i}
                        >
                          {e.icon}
                          {e.text}
                        </Link>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="px-3 flex-shrink-0">
              {updateAvailable && (
                <button
                  type="button"
                  onClick={openConfirm}
                  className="w-full flex items-center gap-2 text-canvas-white text-xs font-outfit bg-canvas-white bg-opacity-10 rounded-lg py-2 px-2"
                >
                  <MdSystemUpdateAlt className="w-4 h-4" />
                  Update available
                </button>
              )}
              <VersionLabel version={currentVersion} className="pt-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
